import React, { useState } from "react";
import "./AdminPanel.css";

interface AdminPanelProps {
  canEdit?: boolean;
  onExportCSV: () => void;
  onImportCSV: () => void;
  onOpenBackup?: () => void;
  onOpenClientProjects?: () => void;
  onOpenUserManagement?: () => void;
  canManageUsers?: boolean;
}

const AdminPanel: React.FC<AdminPanelProps> = ({
  canEdit = true,
  onExportCSV,
  onImportCSV,
  onOpenBackup,
  onOpenClientProjects,
  onOpenUserManagement,
  canManageUsers = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleExportCSV = () => {
    onExportCSV();
    setIsOpen(false);
  };

  const handleImportCSV = () => {
    onImportCSV();
    setIsOpen(false);
  };

  const handleOpenBackup = () => {
    if (onOpenBackup) {
      onOpenBackup();
      setIsOpen(false);
    }
  };

  const handleOpenClientProjects = () => {
    if (onOpenClientProjects) {
      onOpenClientProjects();
      setIsOpen(false);
    }
  };

  const handleOpenUserManagement = () => {
    if (onOpenUserManagement) {
      onOpenUserManagement();
      setIsOpen(false);
    }
  };

  return (
    <div className="admin-panel">
      <button
        className="admin-toggle-button"
        onClick={() => setIsOpen(!isOpen)}
        title="Admin options"
      >
        <span className="admin-icon">⚙️</span>
      </button>

      {isOpen && (
        <div className="admin-menu">
          <button className="admin-menu-item export-csv-button" onClick={handleExportCSV}>
            <span className="export-icon">📥</span>
            Export CSV
          </button>

          {canEdit && (
            <button className="admin-menu-item import-csv-button" onClick={handleImportCSV}>
              <span className="import-icon">📤</span>
              Import CSV
            </button>
          )}

          {canEdit && onOpenBackup && (
            <button className="admin-menu-item backup-button" onClick={handleOpenBackup}>
              <span className="backup-icon">💾</span>
              Save to DB
            </button>
          )}

          {canEdit && onOpenClientProjects && (
            <button className="admin-menu-item client-project-button" onClick={handleOpenClientProjects}>
              <span className="backup-icon">🏷️</span>
              Client Projects
            </button>
          )}

          {canManageUsers && onOpenUserManagement && (
            <button className="admin-menu-item user-management-button" onClick={handleOpenUserManagement}>
              <span className="backup-icon">👥</span>
              User Management
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
